module.exports = __webpack_public_path__ + "2245f4194755e0d6b52084e4fa9930ec.pdf";